(function () {
  const STORAGE_KEY = 'noendy_wishlist_v1';

  function readList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (_e) {
      /* private mode — ignore */
    }
  }

  function has(handle) {
    return readList().some((item) => item.handle === handle);
  }

  function add(item) {
    const list = readList();
    if (list.some((x) => x.handle === item.handle)) return list;
    list.push({ handle: item.handle, title: item.title, image: item.image, url: item.url, addedAt: Date.now() });
    writeList(list);
    dispatchChange();
    return list;
  }

  function remove(handle) {
    const list = readList().filter((item) => item.handle !== handle);
    writeList(list);
    dispatchChange();
    return list;
  }

  function dispatchChange() {
    document.dispatchEvent(new CustomEvent('noendy:wishlist-change', { detail: { items: readList() } }));
  }

  function makeButton(productHandle) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'noendy-wishlist-btn';
    btn.dataset.wishlistHandle = productHandle;
    btn.setAttribute('aria-label', has(productHandle) ? 'Favorilerden çıkar' : 'Favorilere ekle');
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 21s-7-4.5-9.5-9C0.5 8 3.5 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 3.5 0 6.5 4 4.5 8-2.5 4.5-9.5 9-9.5 9z"/>
      </svg>
    `;
    if (has(productHandle)) btn.classList.add('is-active');
    btn.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const card = btn.closest('[data-product-handle], .card-wrapper, .product-card-wrapper, .card');
      const linkEl = card ? card.querySelector('a[href*="/products/"]') : null;
      const titleEl = card ? card.querySelector('.card__heading a, .card__heading, .product-card-wrapper .card__heading') : null;
      const imgEl = card ? card.querySelector('img') : null;

      if (has(productHandle)) {
        remove(productHandle);
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Favorilere ekle');
        if (window.NoendyToast) window.NoendyToast.show({ title: 'Favorilerden çıkarıldı', type: 'info' });
      } else {
        add({
          handle: productHandle,
          title: titleEl ? titleEl.textContent.trim() : '',
          image: imgEl ? imgEl.currentSrc || imgEl.src : '',
          url: linkEl ? linkEl.getAttribute('href') : `/products/${productHandle}`
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Favorilerden çıkar');
        if (window.NoendyToast) window.NoendyToast.show({ title: 'Favorilere eklendi', message: 'Hemen ya da sonra alabilirsin.', type: 'success' });
      }
    });
    return btn;
  }

  function injectOnCards() {
    const cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper, .card');
    cards.forEach((card) => {
      if (card.querySelector('.noendy-wishlist-btn')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      const handle = match[1];
      card.style.position = card.style.position || 'relative';
      card.appendChild(makeButton(handle));
    });
  }

  function updateCounters() {
    const count = readList().length;
    document.querySelectorAll('[data-noendy-wishlist-count]').forEach((el) => {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
      el.closest('.noendy-wishlist-counter')?.setAttribute('data-count', String(count));
    });
  }

  function injectHeaderIcon() {
    if (document.querySelector('.noendy-wishlist-counter')) return;
    const iconsHost = document.querySelector('.header__icons');
    if (!iconsHost) return;
    const cartIcon = iconsHost.querySelector('#cart-icon-bubble');
    const count = readList().length;
    const link = document.createElement('a');
    link.className = 'noendy-wishlist-counter header__icon link focus-inset';
    link.href = '/pages/favorilerim';
    link.setAttribute('aria-label', 'Favorilerim');
    link.setAttribute('data-count', String(count));
    const badgeHtml = count > 0
      ? `<span class="noendy-wishlist-counter__badge" data-noendy-wishlist-count>${count}</span>`
      : `<span class="noendy-wishlist-counter__badge" data-noendy-wishlist-count hidden></span>`;
    link.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0L12 5.35l-.77-.77a5.4 5.4 0 0 0-7.65 7.65L12 21.5l8.42-9.27a5.4 5.4 0 0 0 0-7.65z"/>
      </svg>
      ${badgeHtml}
    `;
    if (cartIcon) {
      iconsHost.insertBefore(link, cartIcon);
    } else {
      iconsHost.appendChild(link);
    }
  }

  function renderWishlistPage() {
    const target = document.querySelector('[data-noendy-wishlist-target]');
    if (!target) return;
    const items = readList();
    if (items.length === 0) {
      target.innerHTML = `
        <div class="noendy-wishlist-empty">
          <p>Henüz bir favorin yok.</p>
          <a class="button button--primary" href="/collections/all">Alışverişe başla</a>
        </div>
      `;
      return;
    }
    target.innerHTML = items.map((item) => `
      <article class="noendy-wishlist-item" data-handle="${item.handle}">
        <a class="noendy-wishlist-item__media" href="${item.url}">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </a>
        <div class="noendy-wishlist-item__body">
          <h3 class="noendy-wishlist-item__title"><a href="${item.url}">${item.title || item.handle}</a></h3>
          <button type="button" class="noendy-wishlist-item__remove" data-remove="${item.handle}">Çıkar</button>
        </div>
      </article>
    `).join('');

    target.querySelectorAll('[data-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        remove(btn.dataset.remove);
        renderWishlistPage();
      });
    });
  }

  function init() {
    injectHeaderIcon();
    injectOnCards();
    updateCounters();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('noendy:wishlist-change', () => {
    updateCounters();
    renderWishlistPage();
    document.querySelectorAll('.noendy-wishlist-btn').forEach((btn) => {
      const handle = btn.dataset.wishlistHandle;
      if (has(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  });

  document.addEventListener('shopify:section:load', injectOnCards);
  document.addEventListener('shopify:section:unload', updateCounters);

  window.NoendyWishlist = { readList, add, remove, has };
})();
